var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.91237C4.17083 1.91237 1.06667 5.01653 1.06667 8.8457C1.06667 12.6749 4.17083 15.779 8 15.779C11.8292 15.779 14.9333 12.6749 14.9333 8.8457C14.9333 5.01653 11.8292 1.91237 8 1.91237ZM0 8.8457C0 4.42743 3.58172 0.845703 8 0.845703C12.4183 0.845703 16 4.42743 16 8.8457C16 13.264 12.4183 16.8457 8 16.8457C3.58172 16.8457 0 13.264 0 8.8457ZM7.99948 7.24544C8.29403 7.24544 8.53281 7.48422 8.53281 7.77878V12.0454C8.53281 12.34 8.29403 12.5788 7.99948 12.5788C7.70493 12.5788 7.46615 12.34 7.46615 12.0454V7.77878C7.46615 7.48422 7.70493 7.24544 7.99948 7.24544ZM7.99948 5.11263C7.70493 5.11263 7.46615 5.35141 7.46615 5.64596C7.46615 5.94052 7.70493 6.1793 7.99948 6.1793H8.01015C8.3047 6.1793 8.54348 5.94052 8.54348 5.64596C8.54348 5.35141 8.3047 5.11263 8.01015 5.11263H7.99948Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.af7e3a46eccf9ee44ba273042531fece.svg";
export { ForwardRef as ReactComponent };